// assets
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import PeopleIcon from '@mui/icons-material/People';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import ContactsIcon from '@mui/icons-material/Contacts';

import UploadFileIcon from '@mui/icons-material/UploadFile';
import { TAM_AN_LUU_TRU } from 'ui-component/dangkyluutru/tamAn';
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const banquanly = {
    id: 'banquanly',
    title: 'Ban Quản Lý',
    type: 'group',
    children: [
        {
            id: 'bql-thong-tin-hanh-sinh',
            title: 'Thông tin hạnh sinh',
            type: 'item',
            url: '/bql-thong-tin-hanh-sinh',
            icon: PeopleIcon,
            breadcrumbs: false
        },
        {
            id: 'bql-ket-qua-tu-tap',
            title: 'Kết quả tu tập',
            type: 'item',
            url: '/bql-ket-qua-tu-tap',
            icon: AutoStoriesIcon,
            breadcrumbs: false
        },
        {
            id: 'bql-ket-qua-tu-hoc',
            title: 'Kết quả tu học',
            type: 'item',
            url: '/bql-ket-qua-tu-hoc',
            icon: Diversity3Icon,
            breadcrumbs: false
        },
        {
            id: 'bql-diem-kiem-tra',
            title: 'Điểm tu học & tu tập',
            type: 'item',
            url: '/bql-diem-kiem-tra',
            icon: DomainVerificationIcon,
            breadcrumbs: false
        },
        {
            id: 'bql-dang-ky-luu-tru',
            title: 'Đăng ký lưu trú',
            type: 'item',
            url: '/bql-dang-ky-luu-tru',
            icon: ContactsIcon,
            breadcrumbs: false
        },
        {
            id: 'ban-quan-ly-ke-hoach-thuc-tap',
            title: 'Kế hoạch thực tập',
            type: 'item',
            url: '/ban-quan-ly-ke-hoach-thuc-tap',
            icon: UploadFileIcon,
            breadcrumbs: false
        }
    ]
};

if (TAM_AN_LUU_TRU) banquanly.children = banquanly.children.filter((m) => m.id !== 'bql-dang-ky-luu-tru');

export default banquanly;
